import type { LinkQueryResult } from '@/components/traceInspector/traceInspector.types';

const SIEBEL_BOT = {
  __typename: 'Account_User',
  name: 'Siebel Bot',
  avatar:
    'https://media-api.us.stratumn.com/files/11142f75cbb0fede41b19290e24ab016a60b66ba6ca5',
  email: 'siebelBot@conduent.com',
  rowId: '0'
} as const;
/** Let's hope this is temporary :) */
export const getLinkCreatedBy = (
  link: LinkQueryResult,
  linkCreatedByAccount: any
) => {
  if (
    isAdminAndShouldBeSiebelBot(
      link.actionKey,
      linkCreatedByAccount?.entity?.email
    )
  ) {
    return SIEBEL_BOT;
  }
  return linkCreatedByAccount?.entity;
};

const isAdminAndShouldBeSiebelBot = (actionKey: string, email: string) =>
  actionKey === 'updateToday' && email === 'admin@stratumn.com';
